
<h2>{{L("SELECT_TECH_USER")}}</h2>
<div class="tech-user-box">
    <dx-tag-box [dataSource]="rqs.approver" [(value)]="edit.data" displayExpr="u_fullName" valueExpr="u_id"></dx-tag-box>
</div>